import React from 'react';
import {CameraCalculator} from '../components/CameraCalculator';
import {useSeo} from '../hooks/useSeo';

export function KalkulatorPage() {
    useSeo({
        title: 'Kalkulator kosztów monitoringu Mielec (39-300) - wycena kamer online | kamerymielec.pl',
        description:
            'Policz online szacunkowy koszt montażu kamer i monitoringu w Mielcu oraz w promieniu do 250 km (Rzeszów, Tarnów, Dębica, Stalowa Wola, Tarnobrzeg, Sandomierz, Kolbuszowa, Kraków, Kielce). Dobierz liczbę kamer, rozdzielczość i opcje - bezpłatnie i bez czekania.',
        canonicalPath: '/kalkulator',
        keywords:
            'kalkulator monitoringu Mielec, kalkulator kamer, cena monitoringu Mielec, kalkulator CCTV Mielec, ile kosztuje montaż kamer Mielec, monitoring cennik',
        breadcrumbs: [
            {name: 'Strona główna', path: '/'},
            {name: 'Kalkulator kosztów', path: '/kalkulator'},
        ],
    });

    return <CameraCalculator/>;
}
